/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Token/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaInputWithLabelField from 'DesignSystem/TysiaInputWithLabelField/index'
import VisibilityAction from './VisibilityAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Token({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/PaymentProviders/AddAction/Content/Content/Payabli/Token",
  isInvalid
  
}) {
  let flow = fromFlow.useFlow()
let addProviderPayabliTokenValueData = fromData.useDataValue({ viewPath,
context: 'add_provider',
path: 'payabli.token',
})
let addProviderPayabliTokenIsValidData = fromData.useDataIsValid({ viewPath,
context: 'add_provider',
path: 'payabli.token',
validate: fromHelpers.validate,
required: true,
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let onChange = fromHelpers.useOnChange({
  children,
  viewPath,
  isInvalid
  
})
  return (<React.Fragment
>
<div
  data-testid="Token.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaInputWithLabelField
  viewPath={`${viewPath}/TysiaInputWithLabelField`}
 marginTop={0}
 marginBottom={0}
 backgroundColor={dtColorsWhite}
 label="PayPoint API token for location"
 data="add_provider.payabli.token"
 value={addProviderPayabliTokenValueData}
 onChange={onChange}
 required={true}
 validate="helpers.js validate"
 invalid={!addProviderPayabliTokenIsValidData}
 type={flow.has(fromFlow.normalizePath(viewPath, 'VisibilityAction/Show')) ? "text" : "password"}
/>
<VisibilityAction
  viewPath={`${viewPath}/VisibilityAction`}
/>
</div>
{children}
</React.Fragment>)
}